export default __webpack_public_path__ + "static/media/guide_me@3x.d8a1e2a9.png";